import React, { useState } from 'react';
import { cloneDeep } from 'lodash';
import styled from 'styled-components';

import {
  ALL_MODULES,
  ALL_SHARD_MODULES,
  AsyncCheckbox,
  AsyncRadio,
  AsyncSelect,
  CustomDateField,
  CustomTextField,
  HeaderTag,
  getTranslatedText,
  CUSTOM_FIELDS,
  SecureText,
  NEW_MODULE_MAP
} from '@nile/components';
import { AccountClient, useQuery } from '@nile/graphql';
import { GET_ALL_FIELDS_V2 } from '@nile/banyan/src/Graphql/Mutations/ticket';

const FieldWrapper = styled.div`
  .cf-wrapper {
    padding-left: 0;
    width: 100%;
    max-width: 100% !important;
    .cf-label {
      margin-bottom: 0.4rem;
    }
    .react-datepicker__input-container {
      input {
        font-weight: 400;
        padding-left: 0;
        width: 100% !important;
      }
    }
  }
  &:hover {
    .action-items {
      visibility: visible;
    }
  }
`;

export function UserCustomField(props) {
  const { field, userCustomFields, updateUser, user, module } = props;

  const updateSelection = (val) => {
    const allCustomFields = cloneDeep(userCustomFields || {});
    if (val?.label) {
      allCustomFields[field.columnName] = val.label;
    } else if (field.fieldType === 'MULTI_SELECT') {
      allCustomFields[field.columnName] = val
        ? val.map((el) => el?.label || el)
        : null;
    } else {
      allCustomFields[field.columnName] = val ? val.toString() : null;
    }
    updateUser(JSON.parse(JSON.stringify(allCustomFields)));
  };

  const getCustomField = () => {
    const value = userCustomFields?.[field.columnName] || '';
    let fieldValue = userCustomFields?.[field.columnName] || '';
    if (fieldValue && field.fieldType === 'SELECT') {
      fieldValue = {
        name: fieldValue,
        value: fieldValue,
        label: fieldValue
      };
    } else if (fieldValue && field.fieldType === 'MULTI_SELECT') {
      fieldValue = fieldValue.map((el) => {
        return {
          name: el,
          value: el,
          label: el
        };
      });
    }
    switch (field.fieldType) {
      case 'RADIO':
        return (
          <AsyncRadio
            module={module || ALL_MODULES.requester}
            defaultValue={fieldValue}
            field={field}
            value={fieldValue}
            updateSelection={updateSelection}
          />
        );
      case 'CHECKBOX':
        return (
          <AsyncCheckbox
            module={module || ALL_MODULES.requester}
            defaultValue={value}
            field={field}
            value={value}
            updateSelection={updateSelection}
          />
        );
      case 'TEXT':
      case 'PARAGRAPH':
      case 'NUMERIC':
      case 'DECIMAL':
        return (
          <CustomTextField
            module={module || ALL_MODULES.requester}
            defaultValue={value?.toString()}
            field={field}
            value={value?.toString()}
            updateSelection={updateSelection}
          />
        );
      case 'DATE':
      case 'DATETIME':
        return (
          <CustomDateField
            module={module || ALL_MODULES.requester}
            defaultValue={value}
            field={field}
            value={value}
            updateSelection={updateSelection}
          />
        );
      case 'SELECT':
      case 'MULTI_SELECT':
        return (
          <AsyncSelect
            module={module || ALL_MODULES.requester}
            defaultValue={fieldValue}
            field={field}
            isMulti={field.fieldType === 'MULTI_SELECT'}
            value={fieldValue}
            updateSelection={updateSelection}
          />
        );
      case CUSTOM_FIELDS.secureText:
        return (
          <SecureText
            module={module || ALL_MODULES.requester}
            defaultValue={fieldValue}
            field={field}
            value={fieldValue}
            updateSelection={updateSelection}
            entityId={user?.userId}
          />
        );
      default:
        return <div>{field.label}</div>;
    }
  };

  return (
    <FieldWrapper className="flex fw">{getCustomField(field)}</FieldWrapper>
  );
}

const UserCustomFieldList = (props) => {
  const { intl, user, module } = props;

  const [allCustomFields, setAllCustomFields] = useState([]);

  const { loading, error } = useQuery(GET_ALL_FIELDS_V2, {
    variables: {
      input:
        NEW_MODULE_MAP[module] ||
        ALL_SHARD_MODULES[module] ||
        ALL_SHARD_MODULES.requester
    },
    client: AccountClient,
    fetchPolicy: 'network-only',
    onCompleted({ getAllFields }) {
      const customFields = getAllFields
        ? getAllFields.filter((el) => el.fieldCategory === 'CUSTOM')
        : [];
      setAllCustomFields(customFields);
    }
  });

  if (loading) return <div>Loading...</div>;

  if (error) return <div>Error</div>;

  if (!allCustomFields?.length && !loading && !error) return null;

  return (
    <>
      <div className="flex center fw">
        <HeaderTag
          title={getTranslatedText(intl, 'client.new.additional.label')}
          type="16px"
          isNewLayout
        />
      </div>
      <div className="fw">
        {allCustomFields.map((field) => {
          return (
            <UserCustomField
              userCustomFields={props.userCustomFields}
              updateUser={props.updateUser}
              field={field}
              intl={intl}
              user={user}
              module={module}
            />
          );
        })}
      </div>
    </>
  );
};

export default UserCustomFieldList;
